import {FC, useEffect, useState} from "react";
import {Navbar} from "react-bootstrap";
import classNames from "classnames";
import NavbarTopElements from "./navbarTopElements";
import {useSidebar} from "@hooks/selectors/panel.selectors";
import {sidebarActions} from "@store/sidebarStore";
import { useAppDispatch } from "@services/hooks/helperHooks";

const NavbarTop: FC = () => {

    const dispatch = useAppDispatch();
    const [showDropShadow, setShowDropShadow] = useState(false);
    const {showBurgerMenu} = useSidebar();
    const toggleBurger = () =>
        dispatch(sidebarActions.setBurgerMenu(!showBurgerMenu));

    const setDropShadow = () => {
        const el = document.documentElement;
        if (el.scrollTop > 0) {
            setShowDropShadow(true);
        } else {
            setShowDropShadow(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', setDropShadow);
        return () => window.removeEventListener('scroll', setDropShadow);
    }, []);

    return (
        <Navbar className={classNames('navbar-glass fs-10 navbar-top sticky-kit', {
            // 'navbar-glass-shadow': showDropShadow
            'navbar-glass-shadow': showDropShadow// && !isChat
        })}
        expand={true}>
            <NavbarTopElements
                navbarCollapsed={false}
                navbarPosition={'vertical'}
                handleBurgerMenu={toggleBurger}
            />
        </Navbar>
    )
}

export default NavbarTop;